<template>
  <div class="wrapper-full nibut">
    <el-container>
      <el-container>
        <el-main
          :style="`height:${dispH - 190 - 63}px;weight:${dispW - 395 - 63};overflow:hidden`"
          class="border-normal"
        >
          <div style="margin-top: 5px">
            <ImageBox
              :src="getImageURL(dispPhoto)"
              :width="dispW - 400"
              :height="dispH - 190"
              :focus="true"
              :colorHex="graphColor"
              :marking="curMarking"
              :info="getInfo()"
              :proc="getProc()"
              :eyetype="getEyeType()"
              :currentUnit="graphUnit"
              :currentPhoto="dispPhoto"
              curPage="meibomian"
              :graphMode="graphMode"
              @init-drawtype="btnDrawToolChange"
              @update="update"
              @focus="onImageFocus"
              @paper="selectPaper"
            />
          </div>
        </el-main>
        <el-footer>
          <el-row style="display: flex; justify-content: flex-end; padding-top: 8px">
            <div style="position: absolute; left: 0">
              <drawType
                v-if="isNeedShowDrawType"
                SubPage="meibomian"
                :toolsBoxWidth="350"
                :toolsBoxHeight="80"
                v-model="graphMode"
              />
            </div>
            <div>
              <el-button class="btn-oprator border-recording retakeStyle" @click="retake('up')">{{
                `${$t("langcfg.txtRetakeUpMeibomian")}`
              }}</el-button>
            </div>
            <div style="margin-left: 14px">
              <el-button class="btn-oprator border-recording retakeStyle" @click="retake('down')">{{
                `${$t("langcfg.txtRetakeDownMeibomian")}`
              }}</el-button>
            </div>
            <div
              class="data-area-style"
              :style="`${currentLanguage === 'it' ? 'position: absolute;right: -300px;font-size: 22px;' : ''}`"
            >
              <div
                v-if="true"
                :style="`margin-bottom:${currentLanguage === 'zh_CN' ? '10px' : '0'};`"
              >
                {{ `${$t("langcfg.txtGlandPercent")}：${glandPercent}%` }}
              </div>
              <div
                v-if="true"
                :style="`${
                  currentLanguage === 'zh_CN'
                    ? 'margin-bottom:10px;'
                    : currentLanguage === 'ja'
                      ? 'margin-bottom:0;line-height:20px;'
                      : 'margin-bottom:0;line-height:30px;'
                }`"
              >
                {{ `${$t("langcfg.txtGlandLoss")}：${glandLossPercent}%` }}
              </div>
              <div :style="`visibility: ${currentLanguage === 'zh_CN' ? 'hidden' : 'visible'};`">
                {{ `${$t("langcfg.txtRecommendedLevel")}：${glandGrade}` }}
              </div>
            </div>
            <div
              class="data-score-style"
              :style="`${
                currentLanguage === 'de'
                  ? 'display: none'
                  : currentLanguage === 'zh_CN'
                    ? 'visibility:visible'
                    : 'visibility:hidden'
              }`"
            >
              <el-form label-position="left" label-width="200px;">
                <el-form-item :label="$t('langcfg.txtRecommendedLevel') + ':'">
                  <el-radio-group v-model="level" @change="radioChange" fill="#409EFF">
                    <el-radio :label="0">0</el-radio>
                    <el-radio :label="1">1</el-radio>
                    <el-radio :label="2">2</el-radio>
                    <el-radio :label="3">3</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-form>
            </div>
          </el-row>
        </el-footer>
      </el-container>
      <el-container>
        <el-aside
          width="395px"
          :style="`height:${
            dispH - 187 - 63
          }px;padding-top:5px;padding-bottom:5px;padding-right:5px;margin-left:1px;`"
        >
          <div style="border: 1px solid gray" class="aside-container">
            <ImageList :photos="photos" @changeShowItem="changeShowItem" :dispH="240" />
          </div>
        </el-aside>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import { Message, Size, SubPageSize } from "../../mixins";
// import fileSys from '../../fileoprators/fileSystem'
import TrendChart from "./basic/TrendChart";
import ImageItem from "./basic/ImageItem";
import ImageList from "./basic/ImageList";
import ImageBox from "../../common/components/ImageBox";
import drawType from "../../common/components/drawType";
import EVENTS from "../../bus";
import { objectCopy, getImageUrl, isDefined } from "../../shared/utils";
import { getMarking, downloadFile } from "../../services/media";
import fileSys from "../../fileoprators/fileSystem";

// import { token } from '../../services/session_token'
// import moment from 'moment'
let img1px = new Image();
img1px.onload = () => {};
export default {
  name: "Meibomian",
  mixins: [Message, Size, SubPageSize],
  data() {
    return {
      graphColor: "#00ff00",
      graphUnit: "mm",
      needUserfulData: {},
      dispPhoto: {},
      currPaper: undefined,
      graphMode: "Select",
      upPhotos: [],
      downPhotos: [],
      photos: [],
      imageListId: 0,
      isNeedShowDrawType: true,
      glandPercent: "--",
      glandLossPercent: "--",
      glandGrade: "--",
      curDirection: "up",
      curRecord: {},
      curMarking: "",
      needDelPhotos: [],
      resultShow: {
        OD: {
          up: {
            gland_loss_percent: "--",
            gland_percent: "--",
            gland_grade: "--",
            level: "--"
          },
          down: {
            gland_loss_percent: "--",
            gland_percent: "--",
            gland_grade: "--",
            level: "--"
          }
        },
        OS: {
          up: {
            gland_loss_percent: "--",
            gland_percent: "--",
            gland_grade: "--",
            level: "--"
          },
          down: {
            gland_loss_percent: "--",
            gland_percent: "--",
            gland_grade: "--",
            level: "--"
          }
        }
      },
      level: 0,
      currentLanguage: ""
    };
  },
  props: {
    record: Object,
    currentEye: {
      type: String,
      default: "OS"
    },
    language: {
      type: String,
      default: ""
    }
  },
  mounted() {
    this.init(this.record, 0);
    // this.init(this.record, 3)
    this.getPhotoMarking();
    this.$bus.$emit(EVENTS.uploadingThirdyParty, "meibomian");
  },
  components: {
    TrendChart,
    ImageItem,
    ImageList,
    ImageBox,
    drawType
  },
  methods: {
    init(record, val) {
      this.curRecord = objectCopy(record);
      this.needUserfulData[this.currentEye] =
        this.curRecord.content[`data${this.currentEye}`]["meibomian"];

      this.getDataPhotos(val);

      this.curDirection =
        this.dispPhoto && this.dispPhoto.direction ? this.dispPhoto.direction : "up";
      this.isNeedShowDrawType = this.dispPhoto.imagelabel === "original";
    },
    update(marking, segments) {
      if (segments && segments.length) {
        let points = new Array(0);
        points.push(segments.length * 2);
        for (let i = 0; i < segments.length; i++) {
          points.push(Math.trunc(segments[i].point.x));
          points.push(Math.trunc(segments[i].point.y));
        }
        if (!this.photos[this.imageListId]) this.imageListId = 3;
        downloadFile(
          this.photos[this.imageListId],
          fileSys.getMediaPath(),
          "MeiboAnayze.jpg",
          () => {
            let filePath = fileSys.getMediaPath("MeiboAnayze.jpg");
            this.photos[this.imageListId].filePath = filePath;
            this.confirm(
              this.$t("langcfg.txtIsReanalysis"),
              this.$t("langcfg.txtOK"),
              this.$t("langcfg.txtCancel"),
              this.$t("langcfg.txtPrompt")
            )
              .then(() => {
                let oldmarking = JSON.parse(marking);

                if (oldmarking.length === 1) {
                  let newmarking = oldmarking[0][1].children;
                  for (let i = 0; i < newmarking.length; i++) {
                    if (!(newmarking[i][1].selected ? newmarking[i][1].selected : false)) {
                      newmarking[i] = ["Path", {}];
                    }
                  }
                  oldmarking[0][1].children = newmarking;
                  marking = JSON.stringify(oldmarking[0]);
                  this.curMarking = JSON.stringify(oldmarking[0]);
                }
                if (oldmarking.length > 1) {
                  let newmarking = oldmarking[1][1].children;
                  for (let i = 0; i < newmarking.length; i++) {
                    if (!(newmarking[i][1].selected ? newmarking[i][1].selected : false)) {
                      newmarking[i] = ["Path", {}];
                    }
                  }
                  oldmarking[1][1].children = newmarking;
                  marking = JSON.stringify(oldmarking[1]);
                  this.curMarking = JSON.stringify(oldmarking[1]);
                }
                this.$bus.$emit(
                  EVENTS.reanalyzeMeibomian,
                  this.photos[this.imageListId],
                  points,
                  this.photos[this.imageListId].direction,
                  marking,
                  (result, newRecord) => {
                    this.curRecord = objectCopy(newRecord);
                    this.init(this.curRecord, this.imageListId);
                    if (isDefined(this.record.content[`data${this.currentEye}`]["meibomian"])) {
                      if (
                        isDefined(
                          this.record.content[`data${this.currentEye}`]["meibomian"]["up"]
                        ) &&
                        isDefined(
                          this.record.content[`data${this.currentEye}`]["meibomian"]["up"].uploaded
                        )
                      ) {
                        this.$bus.$emit(
                          EVENTS.uploadingThirdyParty,
                          "meibomian",
                          this.curRecord,
                          false,
                          true
                        );
                        return;
                      }
                      if (
                        isDefined(
                          this.record.content[`data${this.currentEye}`]["meibomian"]["down"]
                        ) &&
                        isDefined(
                          this.record.content[`data${this.currentEye}`]["meibomian"]["down"]
                            .uploaded
                        )
                      ) {
                        this.$bus.$emit(
                          EVENTS.uploadingThirdyParty,
                          "meibomian",
                          this.curRecord,
                          false,
                          true
                        );
                        return;
                      }
                    }
                  }
                );
              })
              .catch((e) => {
                let oldmarking = JSON.parse(marking);

                if (oldmarking.length === 1) {
                  let newmarking = oldmarking[0][1].children;
                  for (let i = 0; i < newmarking.length; i++) {
                    if (newmarking[i][1].selected ? newmarking[i][1].selected : false) {
                      newmarking[i] = ["Path", {}];
                    }
                  }
                  oldmarking[0][1].children = newmarking;
                  this.curMarking = JSON.stringify(oldmarking[0]);
                } else if (oldmarking.length === 2) {
                  let newmarking = oldmarking[1][1].children;
                  for (let i = 0; i < newmarking.length; i++) {
                    if (newmarking[i][1].selected ? newmarking[i][1].selected : false) {
                      newmarking[i] = ["Path", {}];
                    }
                  }
                  oldmarking[1][1].children = newmarking;
                  this.curMarking = JSON.stringify(oldmarking[1]);
                }
              });
          }
        );
      } else if (!segments) {
        this.$bus.$emit(
          EVENTS.updateData,
          this.curRecord,
          this.photos[this.imageListId],
          [],
          () => {
            this.init(this.curRecord, this.imageListId);
          }
        );
      }
    },

    reloadResShow: function (obj, direction) {
      if (obj && obj.glandpercent !== -1) {
        this.resultShow[this.currentEye][direction].gland_percent =
          obj.glandpercent === 0 ? 0 : Math.floor(obj.glandpercent * 1000) / 10;
      } else {
        this.resultShow[this.currentEye][direction].gland_loss_percent = "--";
        this.resultShow[this.currentEye][direction].gland_grade = "--";
      }
      if (obj && obj.glandloss !== -1) {
        let lossValue = this.resultShow[this.currentEye][direction].gland_loss_percent;
        this.resultShow[this.currentEye][direction].gland_loss_percent =
          obj.glandloss === 0 ? 0 : Math.floor(obj.glandloss * 1000) / 10;
        if (obj.level >= 0) {
          this.resultShow[this.currentEye][direction].gland_grade = obj.level;
          this.resultShow[this.currentEye][direction].level = obj.level;
        } else {
          this.resultShow[this.currentEye][direction].gland_grade =
            this.resultShow[this.currentEye][direction].gland_loss_percent === 0
              ? 0
              : this.resultShow[this.currentEye][direction].gland_loss_percent > 0 &&
                  this.resultShow[this.currentEye][direction].gland_loss_percent <= 33
                ? 1
                : this.resultShow[this.currentEye][direction].gland_loss_percent > 33 &&
                    this.resultShow[this.currentEye][direction].gland_loss_percent <= 66
                  ? 2
                  : 3;
          this.resultShow[this.currentEye][direction].level =
            this.resultShow[this.currentEye][direction].gland_grade;
        }
      } else {
        this.resultShow[this.currentEye][direction].gland_percent = "--";
      }
      this.glandPercent = this.getReultToShow(
        this.resultShow[this.currentEye][direction],
        "gland_percent"
      );
      this.glandLossPercent = this.getReultToShow(
        this.resultShow[this.currentEye][direction],
        "gland_loss_percent"
      );
      this.glandGrade = this.getReultToShow(
        this.resultShow[this.currentEye][direction],
        "gland_grade"
      );
      this.level = this.glandGrade;
    },
    getDataPhotos(val) {
      this.photos = [];
      this.upPhotos = new Array(3);
      this.downPhotos = new Array(3);
      if (this.needUserfulData[this.currentEye] && this.needUserfulData[this.currentEye].up) {
        let recUpPhotos = this.needUserfulData[this.currentEye].up.photos.filter((e) => {
          return e && e.imagelabel !== "";
        });

        for (let id = recUpPhotos.length - 1; id >= 0; id--) {
          if (recUpPhotos[id].imagelabel !== "print") {
            if (recUpPhotos[id].imagelabel === "original") {
              this.upPhotos.splice(0, 1, recUpPhotos[id]);
            } else if (recUpPhotos[id].imagelabel === "enhance") {
              this.upPhotos.splice(1, 1, recUpPhotos[id]);
            } else if (recUpPhotos[id].imagelabel === "contour") {
              this.upPhotos.splice(2, 1, recUpPhotos[id]);
            }
          }
        }
      }
      if (this.needUserfulData[this.currentEye] && this.needUserfulData[this.currentEye].down) {
        let recDownPhotos = this.needUserfulData[this.currentEye].down.photos.filter((e) => {
          return e && e.imagelabel !== "";
        });

        for (let id = recDownPhotos.length - 1; id >= 0; id--) {
          if (recDownPhotos[id].imagelabel !== "print") {
            if (recDownPhotos[id].imagelabel === "original") {
              this.downPhotos.splice(0, 1, recDownPhotos[id]);
            } else if (recDownPhotos[id].imagelabel === "enhance") {
              this.downPhotos.splice(1, 1, recDownPhotos[id]);
            } else if (recDownPhotos[id].imagelabel === "contour") {
              this.downPhotos.splice(2, 1, recDownPhotos[id]);
            }
          }
        }
      }

      this.photos = [...this.upPhotos, ...this.downPhotos];
      // this.photos = this.upPhotos.concat(this.downPhotos)

      this.dispPhoto = this.photos[val]
        ? this.photos[val]
        : val < 3
          ? this.photos[3]
          : this.photos[0];
      if (
        this.needUserfulData[this.currentEye] &&
        this.needUserfulData[this.currentEye].up &&
        (this.needUserfulData[this.currentEye].up.glandloss ||
          this.needUserfulData[this.currentEye].up.glandloss === 0) &&
        this.curDirection === "up"
      ) {
        this.reloadResShow(this.needUserfulData[this.currentEye].up, "up");
      } else if (
        this.needUserfulData[this.currentEye] &&
        this.needUserfulData[this.currentEye].down &&
        (this.needUserfulData[this.currentEye].down.glandloss ||
          this.needUserfulData[this.currentEye].down.glandloss === 0) &&
        this.curDirection === "down"
      ) {
        this.reloadResShow(this.needUserfulData[this.currentEye].down, "down");
      } else if (
        this.needUserfulData[this.currentEye] &&
        ((this.needUserfulData[this.currentEye].up &&
          (this.needUserfulData[this.currentEye].up.glandloss ||
            this.needUserfulData[this.currentEye].up.glandloss === 0)) ||
          (this.needUserfulData[this.currentEye].down &&
            (this.needUserfulData[this.currentEye].down.glandloss ||
              this.needUserfulData[this.currentEye].down.glandloss === 0)))
      ) {
        this.curDirection = this.needUserfulData[this.currentEye].up ? "up" : "down";
        this.reloadResShow(
          this.needUserfulData[this.currentEye][this.curDirection],
          this.curDirection
        );
      }
    },
    changeShowItem: function (id) {
      this.imageListId = id;
      this.dispPhoto = this.photos[id] ? this.photos[id] : id < 3 ? this.photos[3] : this.photos[0];
      this.curDirection = this.dispPhoto.direction ? this.dispPhoto.direction : "up";
      this.reloadResShow(
        this.needUserfulData[this.currentEye][this.curDirection],
        this.curDirection
      );
      this.getPhotoMarking();
      this.isNeedShowDrawType = this.dispPhoto.imagelabel === "original";
    },
    getImageURL: function (file) {
      return getImageUrl((file || {}).filename, window.server, window.token);
    },
    getPhotoMarking: function () {
      if (this.dispPhoto && this.dispPhoto.imagelabel === "original") {
        getMarking(this.dispPhoto.filename, (res) => {
          if (res.message === "OK") {
            this.curMarking = res.marking;
          } else {
            this.curMarking = "";
          }
        });
      } else {
        this.curMarking = "";
        return null;
      }
    },
    getInfo: function () {
      if (this.dispPhoto) {
        let info = {
          eyeType: "os",
          magnification: "16"
        };
        return info;
      } else {
        return undefined;
      }
    },
    getProc: function () {
      if (this.dispPhoto) {
        return this.dispPhoto.imgproc;
      } else {
        return undefined;
      }
    },
    getEyeType: function () {
      if (this.dispPhoto) {
        return this.dispPhoto.eyetype;
      } else {
        return undefined;
      }
    },
    onImageFocus: function (dispid, paper) {
      this.currPaper = paper;
    },
    selectPaper: function (g, paper) {
      this.graph = g;
      this.currPaper = paper;
    },
    btnDrawToolChange: function (val) {
      this.graphMode = val;
    },
    getReultToShow(obj, val) {
      return obj[val] !== undefined && obj[val] !== "" && obj[val] !== -1 ? obj[val] : "--";
    },
    retake: function (updown) {
      this.$emit("show-capture", "meibomian", updown);
    },
    radioChange: function () {
      // 合并数据，上传等级
      this.curRecord.content[`data${this.currentEye}`]["meibomian"][this.curDirection].level =
        this.level;
      this.$bus.$emit(EVENTS.updateData, this.curRecord, "", "", () => {});
      if (isDefined(this.record.content[`data${this.currentEye}`]["meibomian"])) {
        if (
          isDefined(this.record.content[`data${this.currentEye}`]["meibomian"]["up"]) &&
          isDefined(this.record.content[`data${this.currentEye}`]["meibomian"]["up"].uploaded)
        ) {
          this.$bus.$emit(EVENTS.uploadingThirdyParty, "meibomian", this.curRecord, true);
          return;
        }
        if (
          isDefined(this.record.content[`data${this.currentEye}`]["meibomian"]["down"]) &&
          isDefined(this.record.content[`data${this.currentEye}`]["meibomian"]["down"].uploaded)
        ) {
          this.$bus.$emit(EVENTS.uploadingThirdyParty, "meibomian", this.curRecord, true);
          return;
        }
      }
    }
  },
  created() {
    this.currentLanguage = window.settings.language;
  },
  watch: {
    currentEye: {
      handler(newType) {
        this.currentEye = newType;
        this.init(this.record, this.imageListId);
        this.getPhotoMarking();
        // this.changeShowItem(this.imageListId)
      },
      immediate: true,
      deep: true
    },
    dispPhoto: {
      handler(newVal) {},
      immediate: true,
      deep: true
    },
    record: {
      handler(newRecord) {
        if (newRecord && newRecord.content) {
          this.init(newRecord, this.imageListId);
        }
      },
      immediate: true,
      deep: true
    },
    language: {
      handler(newVal) {
        this.currentLanguage = newVal;
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
<style lang="less" scoped>
.footer {
  width: 100%;
  height: 80px;
}
.border-top {
  border-top: solid rgba(gray, 0.1) 1px;
}
.nibut {
  position: relative;
}
.data-area-style {
  // position: relative;
  // width: 260px;
  height: 260px;
  // top: 10px;
  // left: 5px;
  margin: 0 20px;
  text-align: left;
  font-size: 25px;
  font-weight: bold;
  color: white;
  z-index: 50;
}
.btn-oprator {
  border: 1px solid #ccc;
  height: 100px;
}
.retakeStyle {
  height: 80px;
  box-sizing: border-box;
  font-size: 40px;
  padding: 0 20px;
}
.data-score-style {
  // position: absolute;
  // top: 0;
  // right: -68px;
  width: 200px;
  font-size: 25px;
  font-weight: bold;
  color: white;
  // margin-top: 5px;
}
.data-score-style .el-radio-group {
  position: absolute;
  top: 5px;
  left: 65px;
}
.el-radio-group {
  display: flex;
  justify-content: space-between;
}
.data-score-style /deep/ .el-form-item__label {
  font-size: 26px;
}
.data-score-style /deep/ .el-radio__inner {
  margin-left: 30px;
}
.data-score-style /deep/ .el-radio__label {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/dryeye/components/Meibomian.vue